<template>
    <div v-if="isShow">
        <div class="bg" @click="boxClick($event)"></div>
        <div class="divbox">
            <img class="divcode1" :src="subUrl">
            <div :style="blank1Style" ref="blank1" class="blank1"></div>
            <div ref="div1" class="div1">
                <div ref="divbg" class="divbg">
                    <div class="codebg">
                        <img class="divcode" :src="subUrl">
                    </div>
                    <div class="divtitle">
                        长按扫码<br>
                        <span v-if="stinfo == 1">扫码回复<span id="userid" class="red">{{userid}}</span>即可查看</span>
                        <span v-if="stinfo == 2">玩更多好玩心理测试</span>
                    </div>
                </div>
                
                <div id="copybtn" class="copybtn" 
                    v-if="stinfo == 1" 
                    :data-clipboard-text="userid"
                    @click="copyCode">一键复制口令</div>
                <div class="close" @click="closeClick"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: true
        },
        url: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        showClose: {
            type: Boolean,
            default: true
        },
        resultData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isShow: this.show,
            blank1Style: '',
            subUrl: null,
            label1: null,
            stinfo: 0,
            userid: 0,
            copybtn: null,
        }
    },
    mounted() {
        console.log('pop', this.url);
        if (this.isShow) {
            this.blank1Style = this.getBlankStyle1();
        }
        this.initData();
    },
    created() {
        
    },
    destroy() {
        this.copybtn.destroy();
    },
    watch: {
        show(val) {
            // console.log('show', val)
            this.isShow = val
            this.initData();
        },
        isShow(val) {
            // console.log('isShow', val)
            this.$emit('on-show-change', val)
        }
    },
    methods: {
        initData() {
            if (!this.resultData) {
                return;
            }
            this.subUrl = this.resultData.suburl;
            this.userid = this.resultData.userResult.userid;
            this.stinfo = this.resultData.stinfo;
            this.initCopybtn();
            // this.label1 = "长按扫码，即可查看结果";
            // if (this.resultData.stinfo == 1) {
            //     this.label1 = `扫码回复${this.resultData.userResult.userid}即可查看`;
            // }
            
        },
        initCopybtn() {
            if (this.copybtn == null) {
                console.log('init copybtn:', this.stinfo);
                this.copybtn = new ClipboardJS('#copybtn');
                this.copybtn.on('success', (e) => {
                    console.log('clipboard success:', e);
                    e.clearSelection();
                    this.$toasted.show('复制成功');
                });
                this.copybtn.on('error', (e) => {
                    console.log('cliboard error:', e);
                });
            }
        },
        getBlankStyle1() {
            let div1 = this.$refs.div1;
            let winHeight = window.innerHeight;
            let div1Height = div1.offsetHeight;
            let top = (winHeight - div1Height - 20) / window.pxbase;
            console.log(winHeight, div1Height, top);
            return `height:${top}px;`;
        },
        boxClick(e) {
            e.cancelBubble = true
        },
        closeClick() {
            this.isShow = false
        },
        copyCode() {
            console.log('click')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.bg {
    opacity: 0.6;
    background: #000000;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 199;
}
.divbox {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 299;
    .blank1 {
        height: px2rem(260);
        width: 100%;
    }
    .div1 {
        width: px2rem(408);
        margin: auto;
    }
    .divbg {
        margin: auto;
        width: px2rem(408);
        height: px2rem(370);
        
        padding-top: px2rem(30);
        background-color: white;
        border-radius: px2rem(16);

        -webkit-touch-callout:none;
        user-select:none;
        .divtitle {
            text-align: center;
            font-size: px2rem(32);
            font-weight: bold;
            color: #333333;
            .red {
                color: #c9381c;
            }
        }
        .codebg {
            margin: auto;
            width: px2rem(240);
        }
        .divcode {
            width: px2rem(240);
            height: px2rem(240);
        }
    }
    .divcode1 {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 300;
        opacity: 0;
    }
    .copybtn {
        width: px2rem(408);
        height: px2rem(90);
        border: px2rem(2) solid #FFFFFF;
        border-radius: px2rem(12);
        line-height: px2rem(90);
        text-align: center;
        color: white;
        font-size: px2rem(32);
        margin: auto;
        margin-top: px2rem(20);
        z-index: 301;
    }
    .close {
        width: px2rem(80);
        height: px2rem(80);
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('../assets/close.png');
        background-size: px2rem(64);
        position: absolute;
        top: px2rem(-40);
        right: px2rem(-40);
        z-index: 310;
    }
}
</style>